export const CLOCK_IN_OPTIONS = [
  {
    value: 30,
    onWorkText: '上班前30分钟可打卡',
    offWorkText: '下班后30分钟结束打卡'
  }, {
    value: 60,
    onWorkText: '上班前1小时可打卡',
    offWorkText: '下班后1小时结束可打卡'
  }, {
    value: 120,
    onWorkText: '上班前2小时可打卡',
    offWorkText: '下班后2小时结束打卡'
  }, {
    value: 180,
    onWorkText: '上班前3小时可打卡',
    offWorkText: '下班后3小时结束打卡'
  }, {
    value: 360,
    onWorkText: '上班前6小时可打卡',
    offWorkText: '下班后6小时结束打卡'
  }
]

export const ATTENDANCE_TYPE = {
  FLEXIBLE: 1,
  FIXED: 2
}